import dynamic from 'next/dynamic';
import { Builder } from '@builder.io/sdk';

const ExpertQuote = dynamic(() => import('./ExpertQuote').then((m) => ({ default: m.ExpertQuote })));

const ExpertQuoteConfig = {
  name: 'ExpertQuote',
  inputs: [
    {
      name: 'heading',
      type: 'string',
      required: true,
    },
    {
      name: 'body',
      type: 'string',
      required: true,
    },
    {
      name: 'link',
      type: 'string',
      required: false,
    },
    {
      name: 'expert',
      type: 'reference',
      model: 'expert',
      required: true,
    },
  ],
};

Builder.registerComponent(ExpertQuote, ExpertQuoteConfig);
